import React from "react";
import { BookOpenIcon, ClipboardCheckIcon, GitBranchIcon, PrinterIcon, BadgeDollarSignIcon, DownloadIcon } from "lucide-react";
import { whatYouGet } from "../../data/landing";
import { SectionHeading } from "../SectionHeading";
import { TransformCta } from "../TransformCta";
const icons = [BookOpenIcon, ClipboardCheckIcon, GitBranchIcon, PrinterIcon, BadgeDollarSignIcon, DownloadIcon];
export function WhatYouGet() {
  return <section className="px-5 py-16" data-id="element-306" data-mp="1dz0hstcqrjzu">
      <SectionHeading eyebrow="What you'll get" title="Everything organized in one clinical reference system" data-id="element-307" data-mp="191i3enfygckg" />
      <ul className="mx-auto mt-10 grid max-w-4xl gap-4 sm:grid-cols-2" data-id="element-308" data-mp="1nq4utniuwus1">
        {whatYouGet.map((item, i) => {
        const Icon = icons[i];
        return <li key={item.title} className="flex gap-4 rounded-2xl bg-white p-5 shadow-sm ring-1 ring-navy/5" data-id="element-309" data-mp="1iteecz353x63" data-mpi={i}>
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-brand text-white" data-id="element-310" data-mp="1rrzuyop1x248">
                <Icon className="h-6 w-6" aria-hidden="true" data-id="element-311" data-mp="2uyu2zkzmncq9" />
              </span>
              <div data-id="element-312" data-mp="2zxotl93u65kx">
                <h3 className="text-lg font-bold text-ink" data-id="element-313" data-mp="2zx5b9ra9xf6d">{item.title}</h3>
                <p className="mt-1 leading-relaxed text-muted" data-id="element-314" data-mp="34wrnbxed8pdl">{item.text}</p>
              </div>
            </li>;
      })}
      </ul>
      <TransformCta label="Yes, I want the complete system" data-id="element-315" data-mp="39ww31l7g9g2r" />
    </section>;
}